import get from 'lodash/get';
import * as TYPES from '../../constants/actionTypes';
import axiosInstance from '../../utilities/configureAxios';

const intialState = {
  user: null,
  token: null,
  isLoggedIn: null,
  authorities: [],
  applicationConfig: null,
  company: null,
  selectedCompany: null,
  userCompanies: null,
};

const AuthReducer = (state = intialState, action = {}) => {
  switch (action.type) {
    case TYPES.LOGIN:
      return {
        ...state,
        user: get(action, 'payload.data'),
        token: get(action, 'payload.token'),
        isLoggedIn: true,
        company: get(action, 'payload.data.Company'),
        selectedCompany: get(action, 'payload.data.Company'),
        userCompanies: get(action, 'payload.data.UserCompanies'),
        role: get(action, 'payload.data.Role'),
      };

    case TYPES.REFRESH_USER:
      return {
        ...state,
        user: get(action, 'payload.data'),
        token: get(action, 'payload.token'),
        isLoggedIn: true,
        company: get(action, 'payload.data.Company'),
      };

    case TYPES.CHANGE_SELECTED_COMPANY:
      return {
        ...state,
        selectedCompany: get(action, 'payload'),
      };

    case TYPES.LOGOUT:
      return {
        ...intialState,
      };
    case 'persist/REHYDRATE':
      if (get(action, 'payload.auth.token')) {
        axiosInstance.defaults.headers.common.authorization = `Bearer ${get(
          action,
          'payload.auth.token'
        )}`;
      }
      return state;
    default:
      return state;
  }
};
export default AuthReducer;
